export class FeatureSet {
  public features: Feature[];
  public linkData: LinkData;
}

export class Feature {
  public id: number;
  public name: string;
  public notes: string;
  public ownerID: number;
  public ownerDesignerID: string; //not mapped
  public queryParams: string;
  public routerLink: string;
  public section: Section;
  public sectionID: number;
  public seq: number;
}

export class LinkData {
  public isExpired: boolean = false;
  public expiredHtml: string = "";
  public requiresPassword: boolean = false;
  public passwordEntryHtml: string = "";
  public maintenance: boolean = false;
  public maintenanceHtml: string = "";
}

export class Section {
  public id: number;
  public name: string;
  public notes: string;
}
